import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general';
import "./style.sass";
import HeaderMobileCredito from 'components/Header/HeaderMobileCredito';
import { InputTypeAndroid } from 'components/Forms/InputType';
import { useForm } from 'react-hook-form';
import getTelmexStatus from 'services/getTelmexStatus';
import { ModalError } from 'components/Error/ErrorModal';
import { decodeStorage } from 'functions/storageBase64';
import { ModalLoadingCredit } from 'components/Loading'
import { useStorage64 } from 'hooks/useStorageBase64';
import InputPassword from 'components/Forms/InputPassword';
import { PantallaError500 } from '../MensajesErrores/pantallaError500';
import { postLoginTelmex } from 'services/LoginTelmex';


export function ConLineaTelmex() {

    const history = useHistory();
    const profileData = decodeStorage('profileData');

    const EXTERNO = decodeStorage('EXTERNO');

    const [, setInfoLineaTelmexStorage] = useStorage64('infoLineaTelmexStorage', '');

    //respuestas servicios
    const [postLoginTelmexStatusRes, setPostLoginTelmexStatusRes] = useState(false);
    const [getTelmexStatusRes, setGetTelmexStatusRes] = useState(false);


    //variables para modal de error
    const [errorCode, setErrorCode] = useState();
    const [messageResponse, setMessageResponse] = useState();
    const [sectionActive, setSectionActive] = useState("");
    const [showModalErr, setShowModalErr] = useState(false);
    const [ loading, setLoading ] = useState(false);


    // valida respuesta del servicio y si no pasa manda el error
    const handleCloseErr = () => {
        setShowModalErr(false);
        if (sectionActive === 'verificar') {
            window.location.href = `${BASE_PATH}`;
        }
    }

    const handleIrHomePortal = () => {
        // window.location.href = `${BASE_PATH}`;
        history.push(`${BASE_PATH}${SUB_DIRECTORY}solicitud-credito-claroshop/autorizar`);
    };

    const handleIrCreditoButton = () => {
        history.push(`${BASE_PATH}${SUB_DIRECTORY}solicitud-credito-claroshop/autorizar`);
    };

    //- Codigo de instana para track de pagina 
    useEffect(() => {
        window.ineum('page', 'Telmex  Credit-Page');
        window.ineum('meta', 'portal', 'Credito CS');
        window.scrollTo(0, 0);
    }, [])


    const [inputNumero, setInputNumero] = useState();
    const [inputContrasena, setInputContrasena] = useState();

    const { register, handleSubmit, errors, clearErrors, reset } = useForm({
        defaultValues: {
            numero: "",
            contrasena: "",
        }
    })

    const valNumero = {
        required: 'Campo obligatorio',
        minLength: {
            value: 10,
            message: 'El número debe de contener 10 carácteres'
        },
        maxLength: {
            value: 10,
            message: 'El número debe contener 10 carácteres'
        }
    }
    const valContrasena = {
        required: 'La contraseña es requerida',
    }

     // consulta post login Telmex
     const sendFormInformacionTelmex = data => {
        
        console.log("data form",data);

        setLoading(true);
        postLoginTelmex({
            "phone": data?.numero,
            "password": data?.contrasena
        })
        .then(setPostLoginTelmexStatusRes)
    
    }

    useEffect(() => {
        if (postLoginTelmexStatusRes) {
            console.log("respuesta postLoginTelmexStatusRes",postLoginTelmexStatusRes)
            if (postLoginTelmexStatusRes?.statusCode === 200) {
                setLoading(false);
                //validamos numero telmex
                setLoading(true);
                getTelmexStatus({
                    "externalId": profileData?.idClaro,
                    "numero": inputNumero
                })
                .then(setGetTelmexStatusRes)
            }else if(postLoginTelmexStatusRes?.statusCode > 200 && postLoginTelmexStatusRes?.statusCode < 500){
                setShowModalErr(true);
                setErrorCode(postLoginTelmexStatusRes?.statusCode);
                setSectionActive('login');
                setMessageResponse(postLoginTelmexStatusRes?.data?.data?.telmexDescription);
                setLoading(false);
            }else{
                setErrorCode(postLoginTelmexStatusRes?.statusCode);
                setLoading(false);
            }
        }
    }, [postLoginTelmexStatusRes])



    useEffect(() => {
        if (getTelmexStatusRes) {
            console.log("respuesta getTelmexStatusRes",getTelmexStatusRes)
            if (getTelmexStatusRes?.statusCode === 200) {
                //validacion telmex exitosa
                if(getTelmexStatusRes?.data?.codMen === '200'){
                    setLoading(false);
                    //linea calificada como buena
                    if(getTelmexStatusRes?.data?.respws === "true"){
                        //se guarda variable en el storage para detectar que si tiene linea telmex, y se manda averificar OTP"
                        setInfoLineaTelmexStorage({
                            "LineaTelmex": true,
                        });
                        history.push(`${BASE_PATH}${SUB_DIRECTORY}verificar-identidad`);
                    }
                    //si no es buena
                    else if(getTelmexStatusRes?.data?.respws === "false"){
                        //se guarda variable en el storage para detectar que no tiene linea telmex, y se manda averificar OTP"
                        setInfoLineaTelmexStorage({
                            "LineaTelmex": false,
                        });
                        history.push(`${BASE_PATH}${SUB_DIRECTORY}verificar-identidad`);
                    }
                    else{
                        setShowModalErr(true);
                        setErrorCode(getTelmexStatusRes?.statusCode);
                        setSectionActive('verificar');
                        setMessageResponse("Variable respws vacía o inexistente");
                        setLoading(false);
                    }
                }
                //validacion telmex no exitosa
                else if(getTelmexStatusRes?.data?.codMen === '400'){
                    setShowModalErr(true);
                    setErrorCode(getTelmexStatusRes?.statusCode);
                    setSectionActive('verificar');
                    setMessageResponse(getTelmexStatusRes?.data?.codigo);
                    setLoading(false);
                }
                else{
                    setShowModalErr(true);
                    setErrorCode(getTelmexStatusRes?.statusCode);
                    setSectionActive('verificar');
                    setMessageResponse("Variable codMen vacía o inexistente");
                    setLoading(false);
                }
            }else if(getTelmexStatusRes?.statusCode > 200 && getTelmexStatusRes?.statusCode < 500){
                setShowModalErr(true);
                setErrorCode(getTelmexStatusRes?.statusCode);
                setSectionActive('verificar');
                setMessageResponse(getTelmexStatusRes?.data?.codMen);
                setLoading(false);
            }else{
                setErrorCode(getTelmexStatusRes?.statusCode);
                setLoading(false);
            }
        }
    }, [getTelmexStatusRes])

    //useEffect(() => {
    //    if (returnForm === true) {
    //        setInfoPersonalStorage(datos);
    //        SetReturnForm(false);
    //        nextPage(2);
    //    }
    //}, [returnForm])

    const resetErrors = (value) => {
        let inputId = document.querySelector(`#${value} ~ .error`)
        if (inputId) {
            let valu = value
            clearErrors(valu)
            // reset({
            //     titulo: datosPersonales.titulo,
            //     numero: datosPersonales.numero,
            //     Contrasena: datosPersonales.APaterno,
            //     apellidoM: datosPersonales.AMaterno,
            //     correo: datosPersonales.Email,
            //     telefono: datosPersonales.Telefono
            // });
        }
    }



    return (
        <>
            { loading && <ModalLoadingCredit /> }
            {errorCode >= 500
                ? <PantallaError500 />
                : <>
                    <div className="modalCredito full">
                        <div className="contentModal">
                        {
                            EXTERNO ? null : <HeaderMobileCredito title="Solicitud de Crédito Claroshop" type="back" />
                        }

                            <div className="contenedorGeneral top0">
                                <div className="boxSolicitud">
                                <form onSubmit={handleSubmit(sendFormInformacionTelmex)} className="formularioSolicitudMobile">
                                    <div className="tituloFormulariosMobile">
                                        <p>Ingresa tus datos Mi Telmex</p>
                                    </div>
                                    <>
                                        <div className="divFormMobile">
                                            <InputTypeAndroid
                                                type="text"
                                                name="numero"
                                                id="numero"
                                                placeholder="Número Telmex (10 dígitos)"
                                                refs={register(valNumero)}
                                                className="desktopInput"
                                                autocomplete='name'
                                                setNumero={setInputNumero}
                                                numero={inputNumero}
                                                // value={inputNumero}
                                                errorMessage={errors.numero && errors.numero.message}
                                                pattern={'textOnly'}
                                                maxLength={20}
                                                click={() => resetErrors('numero')}
                                            />
                                        </div>

                                        <div className="loginPage">
                                            <InputPassword
                                                type="text"
                                                name="contrasena"
                                                id="contrasena"
                                                placeholder="Contraseña Mi Telmex"
                                                refs={register(valContrasena)}
                                                className="desktopInput"
                                                setNumero={setInputContrasena}
                                                numero={inputContrasena}
                                                // value={inputContrasena}
                                                errorMessage={errors.contrasena && errors.contrasena.message}
                                                pattern={'textOnly'}
                                                maxLength={20}
                                                click={() => resetErrors('contrasena')}
                                            />
                                        </div>
                                    </>                   
                                </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="boxBtnSolicitar marginBottom30">
                        <button className="btnSolicitar" onClick={handleSubmit(sendFormInformacionTelmex)}> Validar</button>
                    </div>
                </>
                }
                {showModalErr &&
                    <ModalError
                        errorCode={errorCode}
                        section={sectionActive}
                        message={messageResponse}
                        handleClose={handleCloseErr}
                    />
                }

        </>
    )
}